/* eslint-disable indent */
import React, { FC, useState, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import DraggableSBBlock from './DraggableSBBlock';
import presetBlocks from './presetBlocks/presetBlocks';
import DraggablePresetBlock from './DraggablePresetBlock';
import getSurveyPermission from '../../../common/getPermissions';
import * as Styled from './styles';
import { TAppState } from '../../../reducers';

const mapStateToProps = (state: TAppState) => ({
    session: state.session,
    config: state.thirdPartyContent.staffbase.config,
});

const connector = connect(mapStateToProps);

type TProps = ConnectedProps<typeof connector>;

const nameRefToUserFriendlyName = {
    'video-text': 'Video with Text',
};

const QuickBlocks: FC<TProps> = ({ session, config }) => {
    const [allowSurvey, setAllowSurvey] = useState(false);
    const [blocksToBeShown, setBlocksToBeShown] = useState(presetBlocks);
    const { ed397EmailDesignerTables } = useFlags();
    // @ts-ignore property does not exist on type 'never'
    const isWebApp = session.integration === 'APP';

    useEffect(() => {
        setAllowSurvey(getSurveyPermission(session));
        const blocksToShow = presetBlocks.reduce((acc, block) => {
            if (!config && block.nameRef === 'sb-post-empty') {
                return acc;
            }

            // Require that new editor is on before enabling tables.
            if (!ed397EmailDesignerTables && block.nameRef === 'table-content') {
                return acc;
            }

            acc.push(block);
            return acc;
        }, []);

        setBlocksToBeShown(blocksToShow);
    }, [config]);

    return (
        <Styled.PresetBlocksWrapper>
            <div>
                {blocksToBeShown.map((block) => {
                    const { nameRef, blockContent } = block;
                    const hasSurvey = blockContent().content.columns.some((column) =>
                        column.columnItems.some((element) => element.type === 'SURVEY')
                    );
                    // @ts-ignore property does not exist on type 'never'
                    const videoAllowed = nameRef !== 'video-text' || session.features.F_ELEMENT_VIDEO;
                    const staffbaseAllowed = nameRef !== 'sb-post-empty' || isWebApp;
                    const disabledTooltipText =
                        nameRef === 'sb-post-empty'
                            ? 'Only available on app.bananatag.com'
                            : `Request a full product demo to see the "${
                                  nameRefToUserFriendlyName[nameRef as 'video-text']
                              }" Quick block.`;
                    if (hasSurvey && !allowSurvey) {
                        return null;
                    }
                    if (nameRef === 'sb-post-empty') {
                        return <DraggableSBBlock key={nameRef} createBlockContent={blockContent} />;
                    }
                    return (
                        <DraggablePresetBlock
                            key={nameRef}
                            nameRef={nameRef}
                            createBlockContent={blockContent}
                            isEnabled={videoAllowed && staffbaseAllowed}
                            disabledTooltipText={disabledTooltipText}
                        />
                    );
                })}
            </div>
        </Styled.PresetBlocksWrapper>
    );
};

export default connector(QuickBlocks);
